module.exports = function() {
  return new Worker(__webpack_public_path__ + "97168c4db4e937dec8c3.worker.js");
};